import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/taxavenger-logo.png';
import './Footer.scss';
import { IoIosCall, IoIosMap } from 'react-icons/io';
import { MdOutlineEmail } from 'react-icons/md';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <Container>
        <Row className="py-5">
          {/* Logo and Description */}
          <Col lg={4} md={6} className="mb-4">
            <div className="footer-brand">
              <Link to="/home" className="footer-logo">
                <img src={Logo} alt="Taxavenger" className="footer-logo-img" />
              </Link>
              <p className="footer-description mt-3">
                Your trusted partner for import/export procedures, customs
                clearance, and international trade compliance in India.
              </p>
            </div>
          </Col>

          {/* Quick Links */}
          <Col lg={2} md={6} className="mb-4">
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-links">
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/assist-your-import">Assist Your Import</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link to="/feedback">Feedback</Link>
              </li>
              <li>
                <Link to="/blogs">Blogs</Link>
              </li>
            </ul>
          </Col>

          {/* Services */}
          <Col lg={3} md={6} className="mb-4">
            <h5 className="footer-heading">Services</h5>
            <ul className="footer-links">
              <li>
                <Link to="/assist-your-import">Import Assistance</Link>
              </li>
              <li>
                <Link to="/blogs/import-export-guide">Import/Export Guide</Link>
              </li>
              <li>
                <Link to="/contact-us">Customs Clearance</Link>
              </li>
              <li>
                <Link to="/contact-us">Trade Compliance</Link>
              </li>
              <li>
                <Link to="/contact-us">Documentation Support</Link>
              </li>
            </ul>
          </Col>

          {/* Contact Info */}
          <Col lg={3} md={6} className="mb-4">
            <h5 className="footer-heading">Contact Info</h5>
            <div className="footer-contact">
              <div className="contact-item">
                <MdOutlineEmail size={20} />{' '}
                <span className="contact-text">&nbsp;</span>
                <a
                  href="mailto:solutions@taxavengers.in"
                  className="contact-text"
                >
                  solutions@taxavengers.in
                </a>
              </div>
              <div className="contact-item">
                <IoIosCall size={20} />
                <a href="tel:+ 91 8850048087" className="contact-text">
                  + 91 8850048087
                </a>
              </div>
              <div className="contact-item">
                <IoIosMap size={20} />{' '}
                <span className="contact-text">India</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="social-links mt-3">
              <button
                className="social-link"
                onClick={() => window.open('https://facebook.com', '_blank')}
              >
                <i className="fab fa-facebook-f"></i>
              </button>
              <button
                className="social-link"
                onClick={() => window.open('https://twitter.com', '_blank')}
              >
                <i className="fab fa-twitter"></i>
              </button>
              <button
                className="social-link"
                onClick={() => window.open('https://linkedin.com', '_blank')}
              >
                <i className="fab fa-linkedin-in"></i>
              </button>
              <button
                className="social-link"
                onClick={() => window.open('https://instagram.com', '_blank')}
              >
                <i className="fab fa-instagram"></i>
              </button>
            </div>
          </Col>
        </Row>

        {/* Bottom Bar */}
        <Row className="footer-bottom">
          <Col md={6} className="text-center text-md-start">
            <p className="mb-0">
              &copy; {currentYear} TaxAvengers. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-center text-md-end">
            <div className="footer-bottom-links">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span className="separator">|</span>
              <Link to="/terms-of-service">Terms of Service</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
